import React, { useState } from 'react';
import assets from '../assets/assets';

const Album = () => {
    const [activeFilter, setActiveFilter] = useState('*');

    const { b_portfolio, b_portfolio1, b_portfolio2, b_portfolio3, b_portfolio4, b_portfolio5 } = assets();

    // Portfolio data
    const portfolioItems = [
        { id: 1, category: 'selected digital', image: b_portfolio, title: 'Tailoring', type: 'Branding' },
        { id: 2, category: 'web branding', image: b_portfolio1, title: 'Spanio', type: 'Design' },
        { id: 3, category: 'web branding', image: b_portfolio2, title: 'Herbal', type: 'Branding' },
        { id: 4, category: 'selected digital', image: b_portfolio3, title: 'Cropo', type: 'Brochure' },
        { id: 5, category: 'selected branding', image: b_portfolio4, title: 'Violator', type: 'Design' },
        { id: 6, category: 'digital web', image: b_portfolio5, title: 'Pixflow', type: 'Digital' },
    ];

    // Filter portfolio items based on the active filter
    const filteredItems = activeFilter === '*'
        ? portfolioItems
        : portfolioItems.filter(item => item.category.includes(activeFilter.replace('.', '')));

    return (
        <section className="position-relative">
            <div className="container">
                <div className="row align-items-center mb-4">
                    <div className="col-xl-5 lg-mb-30px text-center text-xl-start">
                        <h3 className="text-dark-gray fw-700 mb-0 ls-minus-2px">Recent case studies</h3>
                    </div>
                    <div className="col-xl-7 tab-style-04 text-center text-xl-end">
                        <ul className="portfolio-filter nav nav-tabs justify-content-center justify-content-xl-end border-0 fw-500">
                            <li className="nav">
                                <div
                                    className={`nav-link text-dark ${activeFilter === '*' ? 'active' : ''}`}
                                    onClick={() => setActiveFilter('*')}
                                >
                                    All
                                </div>
                            </li>
                            <li className="nav">
                                <div
                                    className={`nav-link text-dark ${activeFilter === '.selected' ? 'active' : ''}`}
                                    onClick={() => setActiveFilter('.selected')}
                                >
                                    Selected
                                </div>
                            </li>
                            <li className="nav">
                                <div
                                    className={`nav-link text-dark ${activeFilter === '.digital' ? 'active' : ''}`}
                                    onClick={() => setActiveFilter('.digital')}
                                >
                                    Digital
                                </div>
                            </li>
                            <li className="nav">
                                <div
                                    className={`nav-link text-dark ${activeFilter === '.branding' ? 'active' : ''}`}
                                    onClick={() => setActiveFilter('.branding')}
                                >
                                    Branding
                                </div>
                            </li>
                            <li className="nav">
                                <div
                                    className={`nav-link text-dark ${activeFilter === '.web' ? 'active' : ''}`}
                                    onClick={() => setActiveFilter('.web')}
                                >
                                    Web
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 filter-content p-md-0">
                        <ul className="portfolio-modern portfolio-wrapper">
                            <li className="grid-sizer"></li>

                            {/* Render filtered portfolio items */}
                            <div className='row'>
                                {filteredItems.map(item => (
                                    <li key={item.id} className={`grid-item col-6 col-md-3 crdmargin ${item.category} transition-inner-all`} style={{marginTop: '1rem', marginBottom: '0.3rem' }}>
                                        <a href="#">
                                            <div className="portfolio-box">
                                                <div className="portfolio-image border-radius-4px">
                                                    <img src={item.image} alt={item.title} />
                                                </div>
                                                <div className="portfolio-hover box-shadow-extra-large">
                                                    <div className="bg-white d-flex align-items-center align-self-end text-start border-radius-4px ps-30px pe-30px pt-20px pb-20px lg-p-20px w-100">
                                                        <div className="me-auto">
                                                            <div className="fs-12 fw-500 text-medium-gray text-uppercase lh-24">{item.type}</div>
                                                            <div className="fw-700 text-dark-gray text-uppercase lh-initial">{item.title}</div>
                                                        </div>
                                                        <div className="ms-auto"><i className="feather icon-feather-plus icon-extra-medium text-dark-gray lh-36"></i></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                    </li>
                                ))}
                            </div>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Album;